import { createClient } from "@supabase/supabase-js";
import type { DatabaseWithCustomTypes } from "@gotoIHUB/db-types";
import { ENVs } from "@/utils/ENVs/ENVs";

export const supabase = createClient<DatabaseWithCustomTypes>(
  ENVs.ViteSupabaseUrl,
  ENVs.ViteSupabasePublishableKey,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
    },
  },
);
